import { Box } from "@chakra-ui/react";
import { call, customEvent, Spacing } from "goi_common";
import { useContext, useEffect } from "react";
import { MubinsoCtaButton, MubinsoScreenLayout } from "../Mubinso/MubinsoUI";
import { MubinsoScreenChromeContext } from "../Mubinso/mubinsoScreenChromeContext";
import { CREMA_GUIDE, CREMA_PHONE } from "./crematoriumConstants";

/**
 * 화장장 퍼널 리드 제출 완료 후 가이드 화면.
 * 전화 연결 CTA + 완료 메시지.
 */
export function CrematoriumGuideScreen() {
  const chrome = useContext(MubinsoScreenChromeContext);

  // 이탈 방지 해제(전화 연결 등이 모달/네이티브 경고에 막히지 않도록)
  useEffect(() => {
    chrome?.setPreventLeave(false);
    return () => chrome?.setPreventLeave(true);
  }, [chrome]);

  return (
    <MubinsoScreenLayout>
      <Box width="100%" whiteSpace="pre-line" className="head2_b black">
        {CREMA_GUIDE.headline}
      </Box>
      <Spacing gap={12} />
      <Box width="100%" whiteSpace="pre-line" className="body_16_r gray600">
        {CREMA_GUIDE.sub}
      </Box>

      <Spacing gap={24} />
      <MubinsoCtaButton
        label={`${CREMA_GUIDE.cta} ${CREMA_PHONE}`}
        onClick={() => {
          customEvent({
            newGtm: { path: "crema_funnel", trigger_and_target: "guide-call" },
          });
          call(CREMA_PHONE);
        }}
      />
      <Spacing gap={80} />
    </MubinsoScreenLayout>
  );
}
